<template>
  <div class="label-search">
    <input @input="input" @click="click" :value="text" class="input-search" type="text" :placeholder="placeholder">
    <div class="search-results-wrapper" v-if="showResults && !!items.length" v-click-outside="closeResults">
      <ul class="search-results" v-if="!!items.length">
        <li v-for="(item, key) in items" :key="key">
          <a :href="item.url" v-html="matchText(item.name)"></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      items: Array,
      placeholder: String
    },
    data() {
      return {
        text: '',
        showResults: false
      }
    },
    methods: {
      input(evt) {
        this.text = evt.target.value;
        this.$emit('input', this.text);
        this.showResults = true;
      },
      click() {
        if (this.items.length) {
          this.showResults = true;
        }
      },
      matchText(name) {
        const expression = new RegExp(`(${this.text})`, 'i');
        return name.replace(expression, '<strong>$1</strong>', "gi");
      },
      closeResults() {
        this.showResults = false;
      },
    }
  }
</script>